<template>
  <div class="deposit-amount-overview">
    <div class="deposit-amount-overview__title">
      <slot name="title"></slot>
    </div>
    <div class="deposit-amount-overview__amount">
      {{ infoAmount }}
    </div>
    <div class="deposit-amount-overview__subtitle">
      <slot name="subtitle"></slot>
    </div>
  </div>
</template>

<script src="./deposit-amount-overview.js"></script>
<style src="./deposit-amount-overview.scss" lang="scss" scoped></style>
